import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { closeModal } from './modalActions';
import UploadPaymentUser from '../user/UserGoingToEvent/UploadPaymentUser';

const PaymentUploadModal = event => {
  const dispatch = useDispatch();
  const closeModalReset = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);
  return (
    <Modal size="mini" open={true} onClose={closeModalReset} closeIcon>
      <Modal.Header style={{ color: 'orangeRed' }}>
        Upload Your Payment
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <UploadPaymentUser event={event} />
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default PaymentUploadModal;
